<template>
  <accounts-component-template
    component-name="Reports"
    component-key="reports"
    color="#B288B3">
    <template v-slot:icon>
      <cloud-refresh-icon :size="16" />
    </template>
    <template v-slot:content>
      <div class="account-reports-component">
        <div>
          <p class="mt-2">Set up a Kibana Customer Account to activate reports.</p>
          <button @click="kibanaAccountSetupModal" class="account-reports-btn">Set up Kibana Customer Account</button>
        </div>
        <div :style="{opacity: !isKibanaSetup ? .5 : 1}">
          <p class="mt-18">Enabling any of these reports displays Reports on the
            main menu of the Account Manager and Account Manager Billing.</p>
          <div class="account-details-checkboxfield">
            <label>
              <input
                  type="checkbox"
                  :checked="volume"
                  :disabled="!isKibanaSetup"
                  @input="setReportType({type: 'volume', value: $event.target.checked})" />
              <span>Volume</span>
            </label>
          </div>
          <div class="account-details-checkboxfield">
            <label>
              <input
                  type="checkbox"
                  :checked="spend"
                  :disabled="!isKibanaSetup"
                  @input="setReportType({type: 'spend', value: $event.target.checked})" />
              <span>Spend</span>
            </label>
          </div>
        </div>
      </div>
    </template>
  </accounts-component-template>
</template>

<style>
  .mt-2 {
    margin-top: 2px;
  }

  .mt-20 {
    margin-top: 18px;
  }
</style>

<script>
import AccountsComponentTemplate from './AccountsComponentTemplate.vue';
import {CloudRefreshIcon} from '../icons';
import {mapGetters, mapActions} from 'vuex';

export default {

  props: {},

  components: {
    AccountsComponentTemplate,
    CloudRefreshIcon,
  },

  mounted () {},

  data () {
    return {
        updateInProgress: false,
    }
  },

  computed: {

      ...mapGetters('AdminAccountDetailsStore', [
          'kibanaReportSettings'
      ]),

      password () {
          return this.kibanaReportSettings.password;
      },

      username () {
          return this.kibanaReportSettings.username;
      },

      volume () {
          return this.kibanaReportSettings.volume;
      },

      spend () {
          return this.kibanaReportSettings.spend;
      },

      isKibanaSetup () {
        return !!this.password && !!this.username;
      }
  },

  methods: {

    ...mapActions('AdminAccountDetailsStore', [
       'updateKibanaReportsSettings'
    ]),

    kibanaAccountSetupModal () {
        const $vm = this;

        this.$modal.show('dialog', {
            title: `Setup Kibana Customer Account`,
            text: `
               <section>
                 <form>
                   <fieldset>
                     <div style="margin-bottom:10px">
                       <label style="display:block" for="username">Kibana Client Username</label>
                       <input id="kibana_popup_username" value="${$vm.username || ''}" name="username" placeholder="Enter Kibana client username"/>
                     </div>
                     <div>
                       <label style="display:block" for="username">Kibana Client Password</label>
                       <input id="kibana_popup_password" value="${$vm.password || ''}" name="username" placeholder="Enter Kibana client password"/>
                     </div>
                   </fieldset>
                 </form>
               </section>
            `,
            buttons: [
                {
                    title: 'Cancel',
                    class: 'vue-dialog-button dialog-cancel-btn',
                    handler: () => {
                        this.$modal.hide('dialog')
                    }
                },
                {
                    title: 'Confirm',
                    class: 'vue-dialog-button dialog-confirm-btn',
                    handler: () => {
                      const password = $('#kibana_popup_password').val();
                      const username = $('#kibana_popup_username').val();

                        //call the route to cancel the review task
                        $vm.updateLoginInfo({
                            username: username,
                            password: password
                        }).then(result => {
                            this.$modal.hide('dialog')
                        })
                    }
                }
            ]
        });
    },

      /**
       * Update kibana account username and password
       *
       * @param payload - {username, password}
       */
    updateLoginInfo (payload) {
        let {username, password} = payload;

        if (!username || !password) {
            return console.error('something missing from kibana credentials');
        }

        return this.updateKibanaReportsSettings({
            username,
            password,
        })
    },

    setReportType (payload) {
        if (this.updateInProgress) return;

        const {type, value} = payload;

        const params = {
            [type]: value,
        };

        this.updateInProgress = true;

        this.updateKibanaReportsSettings(params).then(result => {
            console.log('the report result', result);
            if (!result) {
                console.error('got a kibana error');
                //show some error
            }
        }).finally(result => {
            this.updateInProgress = false;
        })
    }
  }
}
</script>
